import { render, staticRenderFns } from "./raise-notice-entry.vue?vue&type=template&id=b88ad0c0&"
import script from "./raise-notice-entry.vue?vue&type=script&lang=ts&"
export * from "./raise-notice-entry.vue?vue&type=script&lang=ts&"
import style0 from "./raise-notice-entry.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports